import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Button, TableBody, Typography } from '@mui/material';
import { FaCheck, FaMobileAlt, FaRupeeSign, FaTimes } from 'react-icons/fa';
import axios from 'axios';
import Createpurchasemaster from './Createpurchasemaster';
import { FiEdit, FiTrash2 } from 'react-icons/fi'; // Import icons
import Modal from 'react-bootstrap/Modal'; // Assuming you use react-bootstrap for modals




export default function PurchaseMaster() {

    const [customerRes, setCustomerResponse] = React.useState([])


    const customerObj = () => {
        axios.get('https://buildfastvapi.emedha.in/create-customer/api/v1/customers').then((res) => {
            setCustomerResponse(res.data)
        })
    }

    const  customerSearch = (text) => {
        axios.post('https://buildfastvapi.emedha.in/create-customer/api/v1/search', {
            text
        }).then((res) => {
            setCustomerResponse(res.data)
        })
    }

    const [data, setData] = React.useState([])

    const get_prom = () => {
        axios.get("https://buildfastvapi.emedha.in/pmaster/api/v1/get-prouom").then((res) => {
            if (res.data.status === 200) {
                setData(res.data.data)
            }
        })
    }
  
    React.useEffect(() => {
        get_prom()
       
    }, [])

    const [addPurchase, setAddPurchase] = React.useState(false)
    // Add inside your PurchaseMaster component:
const [showEditModal, setShowEditModal] = React.useState(false);
const [editData, setEditData] = React.useState({ slno: '', ProductName: '', UOM: '' });

// --- Edit Handlers ---
const handleEditClick = (row) => {
    setEditData({ slno: row, ProductName: row.ProductName, UOM: row.UOM });
    setShowEditModal(true);
};

const handleUpdateSubmit = () => {
    axios.post('https://buildfastvapi.emedha.in/pmaster/api/v1/update-productmaster', editData)
    .then((res) => {
        if (res.data.status === 200) {
            setShowEditModal(false);
            get_prom(); // Refresh the table
        }
    });
};

// --- Delete Handler ---
const handleDeleteClick = (slno) => {
    console.log("Deleting SLNO:", slno); // 👈 ADD THIS

    if(window.confirm("Are you sure you want to delete this product?")) {
        axios.post('https://buildfastvapi.emedha.in/pmaster/api/v1/delete-productmaster', { slno })
        .then((res) => {
            console.log("Response:", res.data); // 👈 ADD
            if (res.data.status === 200) {
                get_prom();
            }
        });
    }
};



    return (
        <div>


            {/* <div className={!addPurchase ? `leadManagementTable`: ''}>
                {
                    !addPurchase && (
                        <Paper elevation={0} >
                            <TableContainer sx={{ height: 95 + "vh", p: 0.3, pt: 2 }} >

                                <Typography style={{ color: 'rgba(41, 16, 105, 1)', marginBottom: 3, marginLeft: 15.5, fontSize: 18, color: 'gray', fontWeight: '500' }}>Search Filter</Typography>

                                <div style={{ height: '0.1rem', borderBottom: '0.2px solid lightgray' }} ></div>
                                <div className='card mt-3' style={{ border: 'none', paddingLeft: 15, paddingRight: 15, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} >
                                    <div>
                                        <input onChange={(e) => customerSearch(e.target.value)} style={{ height: '2.3rem', color: 'gray', borderRadius: '0.3rem', outline: 'none', width: '26rem', border: '0.7px solid lightgray' }} placeholder='Search user..' />
                                    </div>
                                    <div>
                                        <Button onClick={() => setAddPurchase(true)} style={{ width: '12rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white' }}>+ Purchase Master</Button>
                                    </div>
                                </div>

                                <Table style={{ position: 'relative', top: '1.3rem', overflow: 'scroll' }}>
                                    <TableHead sx={{ borderTop: '1px solid lightgray' }}>
                                        <TableRow>
                                            <TableCell
                                                align={"start"}
                                                style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                            >
                                                Product Names
                                            </TableCell>
                                            <TableCell
                                                align={"start"}
                                                style={{ minWidth: 0, fontSize: 14, fontWeight: '600', color: 'gray', fontSize: 13 }}
                                            >
                                                UOM Names
                                            </TableCell>
 
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                       {
                                        data.map((row => (
                                            <TableRow hover role="checkbox" tabIndex={-1}  key={row.slno}>
                                                       
                                            <TableCell align={"start"}
                                                style={{ top: 57, fontSize: 12, fontWeight: 'bold',color:'grey' }}>{row.ProductName}</TableCell>
                                            <TableCell align={"start"}
                                                style={{ top: 57, fontSize: 12, fontWeight: 'bold',color:'grey' }}>{row.UOM}</TableCell>
                                            
                                        </TableRow>
                                        )))
                                       }
                                              
                                    </TableBody>
                                </Table>
                                {
                                    data.length === 0 && (
                                        <Box className='card' style={{ border: 'none', height: '58vh', width: '100%', boxShadow: 'none', justifyContent: 'center', alignItems: 'center' }} >
                                            <img src='https://cdn-icons-png.flaticon.com/128/2291/2291944.png' width='145px' />
                                            <Typography>0 users</Typography>
                                        </Box>
                                    )
                                }
                            </TableContainer>
                        </Paper>
                    )
                }
                {
                    addPurchase && (
                        <Createpurchasemaster/>
                    )
                }
            </div> */}
            <div className={!addPurchase ? `leadManagementTable` : ''}>
  {!addPurchase && (
    <Paper 
      elevation={0} 
      sx={{ 
        backgroundColor: "transparent", // Ensures it blends with the app background
        padding: 0,
        margin: 0
      }}
    >
      <Box sx={{ height: "95vh", pt: 2 }}>
        
        {/* Header Title */}
        <Typography 
          sx={{ 
            color: '#1B2559', 
            mb: 2, 
            ml: 2, 
            fontSize: { xs: '18px', md: '20px' }, 
            fontWeight: '800',
            letterSpacing: "-0.5px"
          }}
        >
          Purchase Master Records
        </Typography>

        {/* Search & Action Bar - Fully Responsive */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", sm: "center" },
            gap: "15px",
            padding: "15px 20px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            border: "1px solid #E0E5F2",
            mb: 3,
            mx: 2, // Margins to align with the title
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)"
          }}
        >
          <Box sx={{ flex: 1, maxWidth: { xs: "100%", sm: "400px" } }}>
            <input 
              onChange={(e) => customerSearch(e.target.value)} 
              placeholder='Search products...' 
              style={{ 
                width: '100%', 
                height: '45px', 
                padding: '0 15px',
                fontSize: '14px',
                color: '#2B3674', 
                backgroundColor: '#F4F7FE',
                border: '1px solid #E0E5F2',
                borderRadius: '8px', 
                outline: 'none', 
                boxSizing: 'border-box'
              }} 
            />
          </Box>
          <Button 
            onClick={() => setAddPurchase(true)} 
            sx={{ 
              height: '45px', 
              minWidth: '180px',
              width: { xs: "100%", sm: "auto" },
              background: 'linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)', 
              color: 'white',
              fontWeight: '700',
              textTransform: 'none',
              borderRadius: '8px',
              boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.2)",
              "&:hover": { transform: "translateY(-1px)", boxShadow: "0px 6px 15px rgba(67, 24, 255, 0.3)" }
            }}
          >
            + Add Purchase Master
          </Button>
        </Box>

        {/* Table Section - Responsive Wrapper */}
        <TableContainer 
          sx={{ 
            width: 'calc(100% - 32px)', // Accounts for margins
            mx: 2,
                    marginTop:'20px',
            borderRadius: '12px', 
            border: '1px solid #E0E5F2', 
            overflowX: 'auto', // CRITICAL for mobile scrolling
            backgroundColor: '#ffffff',
            maxHeight: '65vh', // Scroll within the page
            '&::-webkit-scrollbar': { height: '6px', width: '6px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
          }}
        >
          <Table stickyHeader sx={{ minWidth: 600 }}> {/* minWidth forces scroll on phones */}
            <TableHead>
              <TableRow 
                sx={{ 
                  background: 'linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)',
                  boxShadow: '0px 4px 10px rgba(67, 24, 255, 0.15)' 
                }}
              >
                <TableCell 
                  align="start" 
                  sx={{ 
                    color: '#ffffff', 
                    fontWeight: '700', 
                    fontSize: '13px', 
                    backgroundColor: 'transparent',
                    borderBottom: 'none',
                    padding: '16px'
                  }}
                >
                  Product Name
                </TableCell>
                <TableCell 
                  align="start" 
                  sx={{ 
                    color: '#ffffff', 
                    fontWeight: '700', 
                    fontSize: '13px', 
                    backgroundColor: 'transparent',
                    borderBottom: 'none',
                    padding: '16px'
                  }}
                >
                  Unit of Measurement(UOM)
                </TableCell>
                <TableCell 
  align="center" 
  sx={{ 
    color: '#ffffff', fontWeight: '700', fontSize: '13px', 
    backgroundColor: 'transparent', borderBottom: 'none', padding: '16px'
  }}
>
  Actions
</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.slno}>
                  <TableCell 
                    align="start" 
                    sx={{ fontSize: '14px', fontWeight: '600', color: '#2B3674' }}
                  >
                    {row.ProductName}
                  </TableCell>
                  <TableCell 
                    align="start" 
                    sx={{ fontSize: '13px', color: '#707eae', fontWeight: '600' }}
                  >
                    {/* Small premium pill badge for UOM */}
                    <span 
                      style={{ 
                        padding: '4px 10px', 
                        backgroundColor: '#F4F7FE', 
                        borderRadius: '6px',
                        border: '1px solid #E0E5F2', 
                        width:"50px"
                      }}
                    >
                      {row.UOM}
                    </span>
                  </TableCell>
                  <TableCell align="center">
  <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
    {/* Edit Icon */}
    <div 
      onClick={() => handleEditClick(row)}
      style={{
        backgroundColor: "#E9EDF7", padding: "8px", borderRadius: "8px", 
        cursor: "pointer", display: "flex", alignItems: "center"
      }}
    >
      <FiEdit style={{ color: "#4318ff", fontSize: "16px" }} />
    </div>

    {/* Delete Icon */}
    <div 
      onClick={() => handleDeleteClick(row["sl.no"])}
      style={{
        backgroundColor: "#FEE2E2", padding: "8px", borderRadius: "8px", 
        cursor: "pointer", display: "flex", alignItems: "center"
      }}
    >
      <FiTrash2 style={{ color: "#E31B23", fontSize: "16px" }} />
    </div>
  </div>
</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Premium Empty State */}
          {data.length === 0 && (
            <Box 
              sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '40vh', 
                width: '100%' 
              }} 
            >
              <img src='https://cdn-icons-png.flaticon.com/128/2291/2291944.png' width='80px' alt="No data" style={{ marginBottom: '16px', opacity: 0.7 }} />
              <Typography sx={{ color: '#A3AED0', fontWeight: '600', fontSize: '15px' }}>
                0 Products Found
              </Typography>
            </Box>
          )}
        </TableContainer>
      </Box>
    </Paper>
  )}


 {/* Render the Add Purchase component and pass the back function */}
  {addPurchase && <Createpurchasemaster onBack={() => setAddPurchase(false)} />}
</div>
{/* Edit Modal */}
<Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
  <Modal.Header closeButton style={{ borderBottom: "1px solid #E0E5F2" }}>
    <Typography sx={{ color: "#1B2559", fontWeight: "800", fontSize: "20px" }}>
      Edit Product
    </Typography>
  </Modal.Header>
  <Modal.Body style={{ padding: "24px" }}>
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {/* Product Name Input */}
      <Box>
        <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
          Product Name
        </Typography>
        <input 
          value={editData.ProductName}
          onChange={(e) => setEditData({...editData, ProductName: e.target.value})}
          style={{
            width: "100%", padding: "12px 15px", fontSize: "14px", color: "#2B3674",
            backgroundColor: "#F4F7FE", border: "1px solid #E0E5F2", borderRadius: "8px", outline: "none"
          }}
        />
      </Box>

      {/* UOM Input */}
      <Box>
        <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
          Unit of Measurement (UOM)
        </Typography>
        <input 
          value={editData.UOM}
          onChange={(e) => setEditData({...editData, UOM: e.target.value})}
          style={{
            width: "100%", padding: "12px 15px", fontSize: "14px", color: "#2B3674",
            backgroundColor: "#F4F7FE", border: "1px solid #E0E5F2", borderRadius: "8px", outline: "none"
          }}
        />
      </Box>
    </Box>
  </Modal.Body>
  <Modal.Footer style={{ borderTop: "1px solid #E0E5F2" }}>
    <Button 
      onClick={() => setShowEditModal(false)} 
      style={{ backgroundColor: "#F4F7FE", color: "#4318ff", border: "none" }}
    >
      Cancel
    </Button>
    <Button 
      onClick={handleUpdateSubmit} 
      style={{ background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", color: "white", border: "none" }}
    >
      Save Changes
    </Button>
  </Modal.Footer>
</Modal>
        </div>
    );
}